var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadersWebsite',{attrs:{"header":"ช่องทางการติดต่อ","img_header":_vm.header_image,"link_back":"managewebsite"}}),_c('ManageContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }